<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12" class="py-3">
        <div>
          <v-icon :color="iconSettinn.color" :size="iconSettinn.size">{{
            iconSettinn.name
          }}</v-icon>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-body-1">
          {{ componentData.description + fromSiteConfigs.name }}
        </div>
      </v-col>
      <v-col>
        <div class="py-1"></div>
        <v-btn block large color="primary" @click="BackFromSite()">
          <span class="mx-2 text-capitalize">{{
            componentData.backFromSite + fromSiteConfigs.pageName
          }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// const fromSiteName = "社群";
// const fromSitePageName = "個人空間頁面";
// const fromSiteUrl = "https://lla.king-fong.com/";

export default {
  name: "VerifyEmailSuccess",
  data() {
    return {
      componentData: {
        title: "信箱驗證成功",
        description: "恭喜您完成信箱驗證，點擊下方按鈕開始使用",
        backFromSite: "前往",
      },
      iconSettinn: {
        name: "mdi-check-circle-outline",
        color: "success",
        size: "50",
      },
      fromSiteConfigs: {
        name: "",
        pageName: "",
        url: "",
      },
    };
  },
  mounted() {
    // 抓queryString (from=) 並在Vuex設定從哪個網站來
    this.fromSiteConfigs = this.$store.state.fromSite;
    console.log(this.fromSiteConfigs);
  },
  methods: {
    BackFromSite() {
      // safari 必須先開視窗
      //   const windowOpen = window.open();
      //   windowOpen.location = this.fromSiteConfigs.url;
      window.location.href = this.fromSiteConfigs.url;
    },
  },
};
</script>
